import React from "react";
import Hero from "components/hero/TwoColumnWithInput";
import AnimationRevealPage from "helpers/AnimationRevealPage";

export default function DownloadApp() {
  return (
    <AnimationRevealPage disabled>
      <Hero />;
    </AnimationRevealPage>
  );
}
